<!--  TODO: add custom icons -->

<mat-form-field class="dn-input-full-width" [ngClass]="{'no-error-indicator': !showValidationIndicators}">
      <mat-label class="dn-input-label ">{{placeholder}}</mat-label>
      <input
        #input
        matInput
        [id]="inputId"
        [autocomplete]="autoComplete"
        [formControl]="formGroup?.get(formControlName)"
        [type]="inputType"
        (keyup)="autoSubmit()" />

      <!-- prefix Icon-->
      <img
        *ngIf="iconUrl"
        matPrefix alt=""
        class="dn-input-icon prefix-icon"
        [src]="iconUrl">



      <!-- Password Toggle Icon -->
      <img
        *ngIf="showViewPasswordIcon && valueFilled"
        matSuffix
        alt=""
        class="dn-input-icon action-icon"
        [src]="passwordSuffixStateIcon"
        (click)="toggleVisible()">

      <span *ngIf="showTextSuffix"  matSuffix class="dn-form-text-suffix" [ngClass]=" {'show-on-hover': suffixShowOnHover}" (click)="suffixClickEvent()">{{suffixEntry}}</span>
      <img *ngIf="showImgSuffix" class="dn-input-icon suffix-icon"  matSuffix alt="" [ngClass]=" {'show-on-hover': suffixShowOnHover}"  [src]="buildSuffixImage" (click)="suffixClickEvent()">

      <!-- Error / Success Icon -->
      <img
        *ngIf="showValidationIndicators && this.formGroup.get(formControlName).dirty"
        class="dn-input-icon dn-input-status-indicator"
        matSuffix
        alt=""
        [src]="this.formGroup.get(formControlName).valid ? validIconUrl : inValidIconUrl"
        [ngClass]="{'error-indicator': !this.formGroup.get(formControlName).valid }">



      <!-- Error Message -->
      <mat-error
        *ngIf="showValidationIndicators && sanitizedErrorMessage"
        class="dn-input-message"
        [innerHTML]="sanitizedErrorMessage" />


      <!--  Assistive Message + Info Icon -->
      <mat-hint
        *ngIf="message"
        class="dn-input-message">
        {{message}}

      </mat-hint>

</mat-form-field>
